"use strict";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.doDevelopmentLogin = void 0;
var _AuthorizationCodeTokenClient = require("../AuthorizationCodeTokenClient");
var _OidcClient = require("../OidcClient");
var _OidcUrlHelper = require("../OidcUrlHelper");
var _constants = require("../constants");
var _storage = require("../storage");
/**
 * Extracts token from current URL.
 * If token is not present in URL and app is without token then this will redirect to identity.
 * Identity on successful login redirects back to app with token in URL.
 */ var doDevelopmentLogin = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(param) {
        var identityUrl, tenant, _window_location_hash_split_, searchParams, oidcUrlHelper, tokenClient, oidcTokenStorage, token, oidcClient;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    identityUrl = param.identityUrl, tenant = param.tenant;
                    searchParams = new URLSearchParams((_window_location_hash_split_ = window.location.hash.split('?')[1]) !== null && _window_location_hash_split_ !== void 0 ? _window_location_hash_split_ : window.location.search);
                    if (!searchParams.has(_OidcUrlHelper.OidcUrlHelper.AUTH_CODE)) return [
                        3,
                        2
                    ];
                    oidcUrlHelper = new _OidcUrlHelper.OidcUrlHelper();
                    tokenClient = new _AuthorizationCodeTokenClient.AuthorizationCodeTokenClient({
                        clientId: _constants.IDENTITY_CLIENT_ID,
                        identityUrl: identityUrl
                    });
                    oidcUrlHelper.storeAuthCodeFromParams(searchParams);
                    return [
                        4,
                        tokenClient.initializeTokenFromAuthorizationCode()
                    ];
                case 1:
                    _state.sent();
                    oidcUrlHelper.handleRedirectAfterLogin();
                    _state.label = 2;
                case 2:
                    oidcTokenStorage = new _storage.OidcTokenStorage();
                    token = oidcTokenStorage.getAccessToken();
                    if (!token) {
                        oidcClient = new _OidcClient.OidcClient({
                            callbackUrl: '#/',
                            redirectUrl: window.location.href
                        }, {
                            clientId: _constants.IDENTITY_CLIENT_ID,
                            identityUrl: identityUrl,
                            acrValues: "tenant:".concat(tenant),
                            scope: 'all'
                        });
                        oidcClient.doLogin();
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return function doDevelopmentLogin(_) {
        return _ref.apply(this, arguments);
    };
}();
exports.doDevelopmentLogin = doDevelopmentLogin; //# sourceMappingURL=doDevelopmentLogin.js.map
